'use client';

import { useEffect } from 'react';
import { Dialog, DialogContent } from '@/shared/ui/core';
import { CookieConsentContent } from '@/features/cookie-consent/ui/cookie-consent-content';
import { useCookieConsent } from '../model/use-cookie-consent';
import { useCookieConsentStore } from '../model/cookie-consent.store';
import styles from './cookie-consent.module.scss';


export function CookieConsentPanel () {
    const { consent } = useCookieConsent();
    const isOpen      = useCookieConsentStore((state) => state.isOpen);
    const open        = useCookieConsentStore((state) => state.open);
    const close       = useCookieConsentStore((state) => state.close);

    useEffect(() => {
        if (!consent) {
            open('banner');
        }
    }, [ consent, open ]);

    return (
        <Dialog
            open={ isOpen }
            onOpenChange={ (next) => { if (!next) close(); } }
            modal={ false }
        >
            <DialogContent
                className={ styles.dialog_panel_content }
                onInteractOutside={ (event) => event.preventDefault() }
            >
                <CookieConsentContent/>
            </DialogContent>
        </Dialog>
    );
}
